import { Box, xcss } from '@atlaskit/primitives';
import { Breadcrumbs, BreadcrumbsItem } from '@atlassian/mpac-primitives';
import React from 'react';

import {
  ContentContainer,
  Description,
  Heading,
  HeroContainer,
  Image,
  ImageContainerDesktop,
  ImageContainerMobile,
} from './Hero.styles';

import type { BackgroundColor } from '@atlaskit/primitives';
import type { ReactNode } from 'react';

export const HeroBackground = ({
  backgroundColor,
  children,
}: {
  backgroundColor: string;
  children: ReactNode;
}) => (
  <Box
    xcss={xcss({
      backgroundColor:
        (backgroundColor as BackgroundColor) || 'color.background.accent.gray.subtlest',
    })}
  >
    {children}
  </Box>
);

export type HeroProps = {
  backgroundColor: string;
  title: string;
  breadcrumbTitle: string;
  description: string;
  imageUrl: string;
  imageAltText: string;
};

export const Hero = ({
  breadcrumbTitle,
  backgroundColor,
  title,
  description,
  imageUrl,
  imageAltText,
}: HeroProps) => {
  return (
    <HeroBackground backgroundColor={backgroundColor}>
      <HeroContainer>
        <ContentContainer>
          <Breadcrumbs>
            <BreadcrumbsItem href="/" text="Marketplace" />
            <BreadcrumbsItem text={breadcrumbTitle} />
          </Breadcrumbs>
          <Heading>{title}</Heading>
          <ImageContainerMobile>
            <Image alt={imageAltText} src={imageUrl} />
          </ImageContainerMobile>
          <Description>{description}</Description>
        </ContentContainer>
        <ImageContainerDesktop>
          <Image alt={imageAltText} src={imageUrl} />
        </ImageContainerDesktop>
      </HeroContainer>
    </HeroBackground>
  );
};
